import { Button, createStyles } from '@mantine/core';
import React from 'react';

import {
  AnalyticsCustomersResponse,
  useCustomersAnalyticsTable,
} from '@portals/api/partners';
import { ReactComponent as InfoCircleIcon } from '@portals/icons/linear/info-circle.svg';
import { AvatarCell, DateCell, PaginatedTable } from '@portals/table';
import { TableColumn, TableFilterTypeEnum } from '@portals/types';

import { AnalyticsWidgetWrapper } from './components/AnalyticsWidgetWrapper';
import { CustomerAnalyticsStatusBadge } from './components/CustomerAnalyticsStatusBadge';

const COLUMNS: Array<TableColumn<AnalyticsCustomersResponse>> = [
  {
    dataField: 'display_name',
    text: 'Customer',
    sort: true,
    filter: {
      type: TableFilterTypeEnum.Text,
    },

    formatter: ({ row }) => (
      <AvatarCell
        src={row.original.logo_url}
        label={row.original.display_name}
        radius="md"
        size={40}
      />
    ),
  },
  {
    dataField: 'claimed_devices',
    text: 'Devices',
    sort: true,
    minWidth: 160,
  },
  {
    dataField: 'users',
    text: 'Users',
    sort: true,
  },
  {
    dataField: 'last_visit',
    text: 'Last visit',
    sort: true,
    minWidth: 170,
    formatter: ({ row }) => <DateCell date={row.original.last_visit} />,
  },
  {
    dataField: 'referral_channel',
    text: 'Referral channel',
    sort: true,
    minWidth: 220,
  },
  {
    dataField: 'status',
    text: 'Status',
    sort: true,
    formatter: ({ row }) => (
      <CustomerAnalyticsStatusBadge status={row.original.status} />
    ),
  },
];

export function CustomersTable() {
  const { classes } = useStyles();

  return (
    <AnalyticsWidgetWrapper widgetTitle="Customers" h={976}>
      <PaginatedTable<AnalyticsCustomersResponse>
        isUrlSyncEnabled={false}
        additionalActions={() => (
          <Button
            size="xs"
            variant="default"
            leftIcon={<InfoCircleIcon className={classes.infoIcon} />}
          >
            Learn more
          </Button>
        )}
        columns={COLUMNS}
        dataHook={useCustomersAnalyticsTable}
        noDataIndication={{ title: 'No Customers' }}
        defaultSortBy={[{ id: 'display_name', desc: false }]}
        keyField="id"
        name="analytics.customers"
        pageSize={1000}
      />
    </AnalyticsWidgetWrapper>
  );
}

const useStyles = createStyles((theme) => ({
  infoIcon: {
    color: theme.colors.indigo_accent[2],
    width: 18,
    height: 18,
  },
}));
